<template>
  <group
    v-for="(group, index) in questionnaireObject.groups"
    :key="group.id"
    :group-object="group"
    @group-update="updateGroup"
  ></group>
</template>


<script>

import Group from './group';
import {reactive, toRef, watch} from "vue";

export default {
  name: "QuestionnaireForm",
  props: {
    questionnaireObject: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      questionnaire: {}
    }
  },
  components: {
    Group,
  },
  setup(props, {emit}) {
    const questionnaire = reactive(toRef(props, 'questionnaireObject'))

    function updateGroup(group) {
      const i = questionnaire.value.groups.findIndex(_element => _element.id === group.id);
      if (i > -1) {
        questionnaire.value.groups[i] = group;
      } else {
        questionnaire.value.groups.push(group);
      }
    }

    watch(
      () => questionnaire,
      (current, previous) => {
        emit('questionnaireUpdate', current.value);
      },
      {
        deep: true
      }
    )

    return {
      questionnaire,
      updateGroup
    }
  }
}
</script>

<style scoped>

</style>
